<!-- 这个被快手、b站详情页使用 -->
<template>
  <div class="cooperationCase ">
    <div class="zhhzqk box-wrap block-wrap" v-loading="loadingObj.getzhBarInfo && loadingObj.getComprehensiveAmount">
      <!-- <div class="top">
        <h5>合作案例</h5>
      </div> -->
      <template v-if="hideCooperationDetailTable == false">
        <div class="tit-wrap">
          <span>达人历史合作明细</span>
          <el-button type="text" @click="() => isCooperationExpand = !isCooperationExpand">
            <span v-if="isCooperationExpand">收起<i class="el-icon-arrow-down"></i></span>
            <span v-else>展开<i class="el-icon-arrow-up"></i></span>
          </el-button>
          <!-- <el-radio-group v-model="zhhzqkForm.wd" size="small">
            <el-radio-button label="ordertype">产品维度</el-radio-button>
            <el-radio-button label="supplier">供应商维度</el-radio-button>
          </el-radio-group> -->
        </div>
        <div v-show="isCooperationExpand" style="margin-top: 20px;">
            <CooperationDetailTable  :plat="plat" :shortId="uid+''" :viewType="viewType" @datachange="onCooperationDataChange"></CooperationDetailTable>
        </div>
      </template>
      <div class="tit-wrap">
        <span>综合合作情况</span>
        <!-- <el-radio-group v-model="zhhzqkForm.wd" size="small">
          <el-radio-button label="ordertype">产品维度</el-radio-button>
          <el-radio-button label="supplier">供应商维度</el-radio-button>
        </el-radio-group> -->
      </div>

      <div class="search-wrap">
        <el-form label-position="top" label-width="80px" :model="zhhzqkForm" size="small" class="zzhzqk-form">
          <el-form-item label="下单日期" class="date-picker">
            <el-date-picker v-model="zhhzqkForm.adddt_ext" type="daterange" range-separator="-" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="产品" class="w140">
            <el-select v-model="zhhzqkForm.order_type" placeholder="请选择" clearable >
              <el-option v-for="item in searchOptionsObj.order_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目行业">
            <el-select v-model="zhhzqkForm.projectType" placeholder="请选择" clearable >
              <el-option v-for="item in searchOptionsObj.projectType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商" class="w140">
            <el-input v-model="zhhzqk_supplier_name" @blur="blur('zh')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="charts-wrap">
        <Bar :info="zhhzqkChartInfo1" isDisposeData></Bar>
      </div>
      <div class="sort-btn-wrap">
        <el-radio-group v-model="orderfield" size="small">
          <el-radio-button :label="item.value" v-for="item in searchOptionsObj.amount_type" :key="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="charts-wrap" v-loading="loadingObj.getComprehensiveAmount">
        <Bar :info="zhhzqkChartInfo2" isDisposeData></Bar>
      </div>
      <div class="two-chart-wrap mt20">
        <div class="left">
          <div class="tit-wrap">
            <span>回款情况</span>
          </div>
          <div class="charts-wrap">
            <Pie :info="collectionPieInfo"></Pie>
          </div>
        </div>
        <div class="right">
          <div class="tit-wrap">
            <span>逾期产品排行</span>
            <!-- <el-radio-group v-model="overdueProductOrder" size="small">
              <el-radio-button label="次数"></el-radio-button>
              <el-radio-button label="金额"></el-radio-button>
            </el-radio-group> -->
          </div>
          <div class="charts-wrap">
            <Bar :info="overdueRankingInfo" isDisposeData></Bar>
          </div>
        </div>
      </div>
      <div class="two-chart-wrap">
        <div class="left">
          <div class="tit-wrap">
            <span>合作营销标的</span>
          </div>
          <div class="charts-wrap">
            <WordCloud :info="productWordCloudInfo"></WordCloud>
          </div>
        </div>
        <div class="right">
          <div class="tit-wrap">
            <span>合作项目行业</span>
          </div>
          <div class="charts-wrap">
            <WordCloud :info="industryWordCloudInfo"></WordCloud>
          </div>
        </div>
      </div>
    </div>
    <!-- 历史合作情况 -->
    <div class="history-wrap box-wrap block-wrap" v-loading="loadingObj.getHisBarInfo && loadingObj.getHisTableData">
      <div class="tit-wrap">
        <span>历史合作情况</span>
        <div class="search">
          <span>产品</span>
          <el-select style="width: 150px" v-model="historyHzqkForm.order_type" placeholder="请选择产品" size="small">
            <el-option v-for="item in searchOptionsObj.order_type" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="search-wrap">
        <el-form label-position="top" label-width="80px" :model="zhhzqkForm" size="small" class="zzhzqk-form">
          <el-form-item label="下单日期" class="date-picker">
            <el-date-picker v-model="historyHzqkForm.adddt_ext" type="daterange" range-separator="-" start-placeholder="开始日期"
              end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="下单类型">
            <el-select v-model="historyHzqkForm.accountnumber" placeholder="请选择" clearable>
              <el-option v-for="item in searchOptionsObj.accountnumber" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目行业">
            <el-select v-model="historyHzqkForm.projectType" placeholder="请选择" clearable>
              <el-option v-for="item in searchOptionsObj.projectType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商" class="w140">
            <el-input v-model="his_supplier_name" @blur="blur('his')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="sort-btn-wrap">
        <el-radio-group  v-model="hisOrderfield" size="small">
          <el-radio-button :label="item.value" v-for="item in searchOptionsObj.amount_type" :key="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="chart-wrap">
        <Bar :info="historyBarChartInfo" isDisposeData></Bar>
      </div>
      <!--
      <div class="tit-wrap">
        <span>合作明细</span>
        <span style="font-size:13px;color:red">我们下单的营销数据按钮显示为橙色</span>
      </div>
      <div class="table-wrap">
        <el-table :data="detailTableData" class="his-detail-table" @sort-change="sortChange" :header-cell-style="{ background: '#f5f7fa' }">
          <el-table-column v-for="(item, idx) in searchOptionsObj.detail_field" :key="idx" :fixed="item.fields === 'product' ? 'left' : false"
            width="150" :sortable="item.ispx ? 'custom' : false" :prop="item.fields" :label="item.name" ></el-table-column>
          <el-table-column width="150" fixed="right" label="营销数据" v-if="plat!=='快手'">
            <template slot-scope="scope">
              <span :class="scope.row.account_number == '我们下单'?'marketingData1':'marketingData'" @click="listItemClick(scope.row.nid, scope.row.ordertype, scope.row.origid,scope.row)">营销数据</span>
            </template>
          </el-table-column>
          <template #empty>
            <div class="no-data-wrap">
              <img src="./images/icon_none.png" alt="">
              <span>暂无数据</span>
            </div>
          </template>
        </el-table>
        <el-pagination
          style="margin-top: 10px"
          background
          layout="prev, pager, next"
          :page-size="detailTableLimit"
          :total="detailTableTotal"
          :current-page.sync="detailTablePage"
          @current-change="changePage">
        </el-pagination>
      </div>
      -->
    </div>

  </div>
</template>

<script>
export default {
  props:{
    plat:{
      type:String,
      default:"抖音"
    },
    shortid:{
      type:String,
      default:""
    },
    viewType:{
      type:String,
      default:"短视频主页"
    },
    hideCooperationDetailTable:{ //是否隐藏合作明细表
      type:Boolean,
      default:false
    }
  },
  components: {
    Bar: () => import("@/components/newEchart/Bar.vue"),
    Pie: () => import("@/components/newEchart/Pie.vue"),
    WordCloud: () => import("@/components/newEchart/WordCloud.vue"),
    CooperationDetailTable: () => import('@/pages/daren/Cooperation/CooperationDetailTable.vue')

  },
  data() {
    return {
      uid: "3852327025388971",
      mcn: "",
      activeName: "1",
      zhhzqkForm: {
        wd: "ordertype",
        adddt_ext: [],
        order_type: "",
        projectType: "",
        supplier_name: "", //供应商
      },
      orderfield: "profit_rate",//金额类型 用来排序
      zhhzqk_supplier_name: "",
      zhhzqkChartInfo1: {},
      zhhzqkChartInfo2: {},
      // overdueProductOrder: "次数",
      collectionPieInfo: { //回款情况
      },
      overdueRankingInfo: {}, //逾期排行榜
      productWordCloudInfo: {},
      industryWordCloudInfo: {},
      historyBarChartInfo: {},
      searchOptionsObj: {
        accountnumber: [],
        amount_type: [],
        order_type: [],
        projectType: [],
      },
      historyHzqkForm: {
        adddt_ext: [],
        order_type: "短视频一口价",
        projectType: "",
        accountnumber: ""
      },
      hisOrderfield: "profit_rate",
      his_supplier_name: "", //历史的供应商
      detailTableData: [],
      detailTableTotal: 0,
      detailTablePage: 1,
      detailTableLimit: 10,
      sortInfo: {
        orderfield: "",
        sort: ""
      },
      auth_order_type: [],
      evaluate:[],

      loadingObj: {
        getHisBarInfo: false,
        getHisTableData: false,
        getzhBarInfo: false,
        getComprehensiveAmount: false
      },

      isCooperationExpand: false //是否展开合作记录
    }
  },
  created() {
    this.auth_order_type = JSON.parse(localStorage.getItem('auth_order_type')) || []
    let talentInfo = JSON.parse(window.sessionStorage.getItem('getDarenInfo'))?.data?.data
    this.uid = talentInfo?.core_user_id || this.$route.query?.shortid || this.shortid
    let plat = localStorage.getItem('plat')
    // this.mcn = talentInfo.mcn_name
    this.zhhzqkForm.order_type = this.viewType == '直播主页' ? '一口价直播' : this.auth_order_type?.[0] || ""
    this.zhhzqkForm.adddt_ext = [this.dayjs().subtract(1, 'year').format("YYYY-MM-DD"), this.dayjs().format("YYYY-MM-DD")]
    this.historyHzqkForm.adddt_ext = [this.dayjs().subtract(1, 'year').format("YYYY-MM-DD"), this.dayjs().format("YYYY-MM-DD")]
    this.historyHzqkForm.order_type =  this.viewType == '直播主页' ? '一口价直播' : this.auth_order_type?.[0] || ""
  },
  watch: {
    zhhzqkForm: {
      handler(newVal) {
        this.getZhhzqkChartsData()
        this.getComprehensiveAmount()
      },
      deep: true
    },
    orderfield: {
      handler(newVal) {
        this.getComprehensiveAmount()
      }
    },
    hisOrderfield: {
      handler(newVal) {
        this.getHisBarInfo()
      }
    },
    historyHzqkForm: {
      handler(newVal) {
        this.getHisBarInfo()
        // this.getHisTableData()
      },
      deep: true
    }
  },
  mounted() {
    this.getOptionsData()
    this.getHisBarInfo()
    // this.getHisTableData()
  },
  methods: {
    getOptionsData() {
      this.$axios.post('/api.php?m=case|api|gx&a=searchList', {
        is_live: this.viewType == '直播主页' ? 1 : 0
      }, {headers: { showLoading: false}}).then(res => {
        if (this.viewType == '直播主页') {
          res.order_type = res.order_type.filter(item=>['一口价直播','一口价直播（框架资源包）','直播-CPA'].includes(item.label))
        }
        console.log(this.searchOptionsObj)
        this.searchOptionsObj = res
      }).catch(err => {} )
    },
    getZhhzqkChartsData() { //综合合作情况
      let form = this._.cloneDeep(this.zhhzqkForm)
      form.adddt_ext_start = form.adddt_ext?.[0] || ""
      form.adddt_ext_end = `${form.adddt_ext?.[1]} 23:59:59` || ""
      delete form.adddt_ext
      let params = {
        ...form,
        supplier_name: this.zhhzqk_supplier_name,
        plat: this.plat,
        shortid: this.uid,
        is_live: this.viewType == '直播主页' ? 1 : 0
      }
      this.loadingObj.getzhBarInfo = true
      this.$axios.post('/api.php?m=case|api|gx&a=comprehensive', params, {headers: { showLoading: false}}).then(res => {
        let {cooperTiemsArr = {}, industry = [], productArr = [], returnedArr = {}, overdueRangeArr = {}} = res
        this.setZhhzqkChartInfo1(cooperTiemsArr)
        this.setReturnedPieChart(returnedArr)
        this.setOverdueRankingInfo(overdueRangeArr)
        this.productWordCloudInfo = {
          data: productArr.map(x => {
            return {
              name: x.product,
              value: x.count
            }
          }),
          custom: {
            series: [ { sizeRange: [12, 40] } ]
          }
        }
        this.industryWordCloudInfo = {
          data: industry.map(x => {
            return {
              name: x.industry,
              value: x.count
            }
          }),
          custom: {
            series: [ { sizeRange: [14, 40] } ]
          }
        }

      }).catch(err => {} )
      .finally(() => {
        this.loadingObj.getzhBarInfo = false
      })
    },
    getComprehensiveAmount() { //综合合作情况-金额类型
      let form = this._.cloneDeep(this.zhhzqkForm)
      form.adddt_ext_start = form.adddt_ext?.[0] || ""
      form.adddt_ext_end = `${form.adddt_ext?.[1]} 23:59:59` || ""
      delete form.adddt_ext
      let params = {
        ...form,
        supplier_name: this.zhhzqk_supplier_name,
        plat: this.plat,
        shortid: this.uid,
        orderfield: this.orderfield,
        is_live: this.viewType == '直播主页' ? 1 : 0
      }
      this.loadingObj.getComprehensiveAmount = true
      this.$axios.post('/api.php?m=case|api|gx&a=comprehensiveAmount', params, {headers: { showLoading: false}}).then(res => {
        this.setChart(res, "now")
      }).catch(err => {} )
      .finally(() => {
        this.loadingObj.getComprehensiveAmount = false
      })
    },
    setZhhzqkChartInfo1(cooperTiemsArr = {}) { //综合合作情况-合作次数
      let endVal = cooperTiemsArr.data[0]?.data.length > 7 ? parseInt(7 / cooperTiemsArr.data[0]?.data.length * 100)  : 100
      this.zhhzqkChartInfo1 = {
        xAxis: cooperTiemsArr.xAxis,
        data: cooperTiemsArr.data.map(x => {
          return {
            barWidth: 16,
            itemStyle: {
              borderRadius: [8, 8, 0, 0]
            },
            ...x
          }
        }),
        custom: {
          title: [
            {
              show: true,
              text: "合作次数",
              left: 0,
              top: 5,
              textStyle: {
                fontSize: 14,
                color: '#333333',
                fontWeight: 400
              }
            },
            {
              show: true,
              text: `总合作：${cooperTiemsArr.sum}次`,
              right: 0,
              top: 5,
              textStyle: {
                fontSize: 12,
                color: '#333333',
                fontWeight: 400
              }
            },
          ],
          legend: {
            show: false
          },
          grid: {
            bottom: 30
          },
          dataZoom: [
            {
              type: 'inside',
              start: 0,
              end: endVal,
            },
            {
              start: 0,
              end: endVal,
              bottom: 10,
              height: 10,
              fillerColor: '#3377FF',
              backgroundColor: "#E8EBF3",
              showDetail: true,
            }
          ],
        }
      }
    },
    setReturnedPieChart(returnedArr = {}) { //回款情况
      let sum = this.$calc(+returnedArr.normal?.value).add(+returnedArr.overdue?.value).end()
      // let sum = +returnedArr.normal?.value + +returnedArr.overdue?.value
      this.collectionPieInfo = {
        showPercent: false,
        data: [
          {
            ...returnedArr.overdue,
            originVal: returnedArr.overdue?.value,
            // value: (+returnedArr.overdue?.value / sum * 100 || 0).toFixed(2),
            value: this.$calc(returnedArr.overdue?.value).div(sum).mul(100).end() || 0,
            color: "#91C0FF"
          },
          {
            ...returnedArr.normal,
            originVal: returnedArr.normal?.value,
            // value: (+returnedArr.normal?.value / sum * 100 || 0).toFixed(2),
            value: this.$calc(returnedArr.normal?.value).div(sum).mul(100).end() || 0,
            color: "#40A0FC"
          },
        ],
        custom: {
          grid: {
            bottom: 0,
          },
          legend: {
            show: false,
          },
          series: [
            {
              radius: ['35%', '55%'],
              itemStyle: {
                borderRadius: 20
              },
              labelLine: {
                length: 10,
                length2: 10,
              },
              label: {
                formatter: function(params){
                  return `{gray|${params.name}: ${(params.value * 1).toLocaleString()}%} \n {bold| 数量：${params.data.originVal}}`
                },
                rich: {
                  gray: {
                    color: "#999999",
                    fontWeight: "400",
                  },
                  bold: {
                    color: "#333333",
                    fontWeight: "500",
                    fontSize: 12,
                    padding: [8, 0, 0, 0]
                  }
                }
              }
            }
          ],
        }
      }
    },
    setOverdueRankingInfo(overdueRangeArr = {}) {
      this.overdueRankingInfo = {
        xAxis: [""],
        data: [
          {
            name: "逾期次数",
            data: overdueRangeArr.data?.[0].data || [],
            barWidth: 16,
            itemStyle: {
              borderRadius: [0, 8, 8, 0]
            },
          },
        ],
        custom: {
          grid: {
            bottom: 0,
            right: 40
          },
          xAxis: {
            show: false,
            type: 'value',
          },
          legend: {
            show: false,
          },
          yAxis: [
            {
              type: 'category',
              inverse: true,
              data: overdueRangeArr.xAxis,
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: true,
                textStyle: {
                  color: '#333333',
                  fontSize: '12',
                  fontWeight: 500,
                },
                formatter: function (value) {
                  return value;
                },
              }
            }
          ],
          series: [
            {
              label: {
                show: true,
                position: 'right',
                color: '#333333',
                fontSize: 12,
                fontWeight: 500,
              }
            }
          ]
        }
      }
    },
    getHisBarInfo() { //历史合作情况
      this.loadingObj.getHisBarInfo = true
      let form = this._.cloneDeep(this.historyHzqkForm)
      form.adddt_ext_start = form.adddt_ext?.[0] || ""
      form.adddt_ext_end = `${form.adddt_ext?.[1]} 23:59:59` || ""
      delete form.adddt_ext
      let params = {
        ...form,
        supplier_name: this.his_supplier_name,
        plat: this.plat,
        shortid: this.uid,
        orderfield: this.hisOrderfield,
        limit: 7,
        is_live: this.viewType == '直播主页' ? 1 : 0
      }
      this.$axios.post('/api.php?m=case|api|gx&a=cooperateOption', params, {headers: { showLoading: false}}).then(res => {
        this.setChart(res, "history")
      }).catch( err => {
        this.loadingObj.getHisBarInfo = false
      })
    },
    getHisTableData() {
      this.loadingObj.getHisTableData = true
      let form = this._.cloneDeep(this.historyHzqkForm)
      form.adddt_ext_start = form.adddt_ext?.[0] || ""
      form.adddt_ext_end = `${form.adddt_ext?.[1]} 23:59:59` || ""
      delete form.adddt_ext
      let params = {
        ...form,
        supplier_name: this.his_supplier_name,
        plat: this.plat,
        shortid: this.uid,
        ...this.sortInfo,
        page: this.detailTablePage,
        limit: this.detailTableLimit,
        is_live: this.viewType == '直播主页' ? 1 : 0
      }
      this.$axios.post('/api.php?m=case|api|gx&a=drcaselist', params, {headers: { showLoading: false}}).then(res => {
        let {rows = [], totalCount = 0} = res || {}
        this.detailTableTotal = totalCount
        this.detailTableData = rows
      }).catch( err => {})
      .finally(() => {
        this.loadingObj.getHisTableData = false
      })
    },
    sortChange({ column, prop, order }) {
      this.detailTablePage = 1
      this.sortInfo = {
        orderfield: prop,
        sort: order ? order.replace('ending','') : ""
      }
      // this.getHisTableData()
    },
    changePage(page) {
      // this.getHisTableData()
    },
    formatter(row, column, unit) {
      if (unit === '%') {
        return (row[column.property] || 0) + unit
      } else {
        return unit + (row[column.property] || 0)
      }
    },
    listItemClick(nid, type, origid, row) { //点击跳转
      let inSalesGroup = window.sessionStorage.getItem('inSalesGroup')
      let name = window.sessionStorage.getItem('name')
      window.sessionStorage.clear()
      window.sessionStorage.setItem('inSalesGroup', inSalesGroup)
      window.sessionStorage.setItem('name', name)
      let routeData

      if(row.starid && row.account_number == "我们下单"){
        if (type === "一口价直播") {
          routeData = this.$router.resolve({
            // path: '/drliveDetail',
            path: '/liveBroadcastDetail',
            query: { id: nid ,origid}
          })
        } else{
          routeData = this.$router.resolve({
            // path: '/cooperationDetail',
            path: '/shortVideoDetail',
            query: { id: nid ,origid}
          })
        }
      }else{
        routeData = this.$router.resolve({
          path: '/cooperationDetail',
          query: { id: origid}
        })
      }

      window.open(routeData.href, "_blank");

      // 合作明细 营销数据跳转埋点
      let logParams = {
        type: 6,
        plat: this.plat == "抖音" ? 1 : this.plat == "快手" ? 2 : this.plat == "B站" ? 3 : null,//和文俊确认一下
        starid: this.$route.query.id || '',
        shortid: this.$route.query.shortid || '',
        tags: [{ field: "origid", value: origid}]
      }
      this.$api.setUseLog(logParams)
    },
    setChart(res, type) {
      let orderfieldKey = type === "now" ? "orderfield" : "hisOrderfield"
      let colorMap = {
        0: this[orderfieldKey] === "profit" ? "rgba(255,102,9, 1)" : "rgba(255,102,9, 0.2)",
        1: this[orderfieldKey] === "profit_rate" ? "rgba(255,91,137, 1)" : "rgba(255,91,137, 0.2)",
        2: this[orderfieldKey] === "order_price" ? "rgba(53,195,251, 1)" : "rgba(53,195,251, 0.2)",
        3: this[orderfieldKey] === "rebate_amount" ? "rgba(39,136,252, 1)" : "rgba(39,136,252, 0.2)",
        4: this[orderfieldKey] === "talent_price" ? "rgba(79,208,137, 1)" : "rgba(79,208,137, 0.2)",
      }
      let chartInfoKey = type === "now" ? "zhhzqkChartInfo2" : "historyBarChartInfo"

      if(chartInfoKey == "historyBarChartInfo"){
        this.evaluate = res.data.splice(5,1)
      }
      let options = {
        xAxis: res.xAxis,
        data: res.data.map((x, idx) => {
          return {
            name: x.name,
            data: x.data,
            barWidth: 16,
            itemStyle: { borderRadius: [8, 8, 0, 0] },
            yAxisIndex: x.name === "利润率" ? 1 : 0,
            type: x.name === "利润率" ? "line" : "bar",
            color: colorMap[idx],
            smooth: true
          }
        }),
        custom: {
          grid: {
            bottom: 30,
            left: 20,
          },
          tooltip: {
            show:true,
            // trigger: 'item',
            formatter:  (data)=>{
              let cur = data[0]
              let str = ""
              data.forEach(dataObj => {
                str+=`<div>${dataObj?.marker? dataObj?.marker : ''}${dataObj.seriesName}:${dataObj.value}</div>`
              });
              if(chartInfoKey == "historyBarChartInfo"&&this.evaluate&&this.evaluate[0]){
                str+=`<div>${this.evaluate[0]?.name?this.evaluate[0]?.name:''}:${this.evaluate[0].data[cur.dataIndex]?this.evaluate[0].data[cur.dataIndex]:''}</div>`
              }

            return str
            }
          },
          legend: {
            selectedMode: true,
            bottom: 0,
            left: "center"
          },
          yAxis: [
            {
              type: 'value',
            },
            {
              type: 'value',
              // min: 0,
              // max: 100,
              name: "%",
              splitLine: {
                lineStyle: {
                  color: '#F5F7F9',
                  type: 'dashed'
                }
              },
            },
          ],
        }
      }

      if(type === "history") {
        options.custom.xAxis = {
          axisLabel: {
            show: false
          },
        }
      }

      this[chartInfoKey] = options
      this.loadingObj.getHisBarInfo = false
    },
    blur(type) {
      if(type === "zh") {
        this.getZhhzqkChartsData()
        this.getComprehensiveAmount()
      }else {
        this.getHisBarInfo()
        // this.getHisTableData()
      }
    },
    onCooperationDataChange(res){
      if(this.isCooperationExpand == false){
        this.isCooperationExpand = +res.totalCount > 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.circle{
  display: block;
  width:10px;
  height:10px;
  color:red
}
  .cooperationCase{
    .box-wrap{
      width: 100%;
      background: #FFFFFF;
      border-radius: 10px;
      padding: 10px 30px 20px;
      box-sizing: border-box;
      margin-bottom: 15px;
      .tit-wrap{
        width: 100%;
        font-size: 16px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        border-bottom: 1px solid #F0F0F0;
        padding-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-height: 55px;
        box-sizing: border-box;
      }
      .search-wrap{
        margin-top: 10px;
        /deep/.el-form.zzhzqk-form{
          display: flex;
          // justify-content: space-between;
          .el-form-item{
            width: 120px;
            margin-right: 20px;
            &:last-of-type{
              margin-right: 0;
            }
            .el-form-item__label{
              padding-bottom: 0;
            }
            &.w140{
              width: 140px;
            }
            &.date-picker{
              box-sizing: border-box;
              width: 220px;
            }
          }
        }
      }
      .sort-btn-wrap{
        text-align: right;
      }
    }
    .zhhzqk{
      .tit-wrap{
        display: flex;
        justify-content: space-between;
      }
      .charts-wrap{
        height: 430px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        >section{
          width: calc((100% - 40px) / 2);
          &:nth-of-type(2) {
            .sort-wrap{
              height: 34px;
              >span{
                font-size: 12px;
                font-family: OPPOSans;
                font-weight: 400;
                color: #333333;
                margin-right: 15px;
              }
            }
            .bar-wrap{
              height: calc((100% - 34px));
            }
          }
        }
      }
    }
    .two-chart-wrap{
      display: flex;
      justify-content: space-between;
      height: 300px;
      &.mt20{
        margin-top: 20px;
      }
      .left, .right{
        width: calc((100% - 40px) / 2);
        .charts-wrap{
          height: 240px;
        }
      }
    }
    .history-wrap{
      .search{
        font-size: 12px;
        font-family: OPPOSans;
        font-weight: 400;
        color: #333333;
        >span{
          margin-right: 15px;
        }
      }
      .chart-wrap{
        height: 400px;
      }
      /deep/ .table-wrap {

      //   .el-table__fixed {
      //     top: -10px;
      //   }
      // // 右侧固定
      //   .el-table__fixed-right {
      //     top: -10px;
      //   }




        .el-table__header-wrapper {
          overflow-x: hidden;
        }

        .marketingData {
          display: inline-block;
          width: 88px;
          height: 34px;
          background: #FFFFFF;
          border: 1px solid #F0F0F0;
          border-radius: 4px;
          line-height: 34px;
          font-size: 14px;
          font-family: OPPOSans;
          font-weight: 500;
          color: #666666;
          text-align: center;
          cursor: pointer;
        }

        .el-table__body-wrapper {
          .price {
            font-size: 20px;
            font-family: OPPOSans;
            font-weight: 800;
            color: #FF5C00;
            text-align: center;
          }
        }

        // .el-table__row.hover-row {
        //   .marketingData {
        //     background: #FF5C00;
        //     border-color: #FF5C00;
        //     color: #fff;
        //   }
        // }
        .marketingData1 {
            display: inline-block;
            width: 88px;
            height: 34px;
            border: 1px solid #F0F0F0;
            border-radius: 4px;
            line-height: 34px;
            font-size: 14px;
            font-family: OPPOSans;
            font-weight: 500;
            text-align: center;
            cursor: pointer;
            background: #FF5C00;
            border-color: #FF5C00;
            color: #fff;
          }

        .el-button {
          border-color: transparent;
          padding: 0;
        }

        .el-button:focus,
        .listItem .el-button:hover {
          color: transparent;
          border-color: transparent;
          background-color: transparent;
        }

        .no-data-wrap{
          padding: 50px;
          display: flex;
          flex-direction: column;
          img{
            width: 50px;
            height: 45px;
            margin-bottom: 10px;
          }
          span{
            color: #A1A1A1;
            line-height: 1;
          }
        }
        .el-pagination{
          text-align: right;
        }
      }
    }
  }
</style>